<template>
  <div>
    <page-header :title="$t('dictionary.log_manage')" />
    <page-body>
      <list :id="listId" :logtype="actions" :apiver="v1" :service="log" />
    </page-body>
  </div>
</template>

<script>
import List from './components/List'

export default {
  name: 'LogManageIndex',
  components: {
    List,
  },
  data () {
    return {
      listId: 'LogManageList',
    }
  },
}
</script>
